import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Organization } from 'src/app/modules/organization-admin/models/organization';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/auth/services/authentication.service';
import { OrganizationAdminService } from 'src/app/modules/organization-admin/services/organization-admin.service';
import { OrgLeavesService } from '../../services/org-leaves.service';
import { LeaveTypesService } from 'src/app/modules/leave-type/services/leave-types.service';


import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDatepicker} from '@angular/material/datepicker';

// Depending on whether rollup is used, moment needs to be imported differently.
// Since Moment.js doesn't have a default export, we normally need to import using the `* as`
// syntax. However, rollup creates a synthetic default module and we thus need to import it using
// the `default as` syntax.
import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { Moment} from 'moment';

const moment =  _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};


@Component({
  selector: 'app-org-leaves-create',
  templateUrl: './org-leaves-create.component.html',
  styleUrls: ['./org-leaves-create.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class OrgLeavesCreateComponent implements OnInit {

  /** USING THIS TO RESET FORM  WITH OUT SHOWING FORMVALIDAITON ERRORS**/
  @ViewChild('myForm', {static: false}) myForm: NgForm;

  public orgLeaveForm:FormGroup;
  public organizations:Organization;

  public hasRole:string = this.authservice.hasRole();
  public orgId:string;

  public isShowAlert:boolean= false;
  public isShowOrganization:boolean = false;

  public leaveTypes:any;



  constructor(private fb:FormBuilder,
    private dialog: MatDialog,
    private authservice:AuthenticationService,
    private organizationService:OrganizationAdminService,
    private orgLeaveService:OrgLeavesService,
    private leaveTypeService: LeaveTypesService

    ) { }

  ngOnInit(): void {
    this.createorgLeaveForm();
    setTimeout(() => {
      this.getLeaveTypes();
    });
    this.checkAuthenticationType();
  }

  checkAuthenticationType():void{
    if(this.hasRole == '1'){
      setTimeout(() => {
        this.getOrganizations();
      });
      this.isShowOrganization = true;
      this.orgId = '';
      this.orgLeaveForm.get("org_id").setValidators([Validators.required]);
      this.orgLeaveForm.get("org_id").updateValueAndValidity();
    }else{
      this.orgId = this.authservice.getOrgId();
    }
  }

  getLeaveTypes():void{
    this.leaveTypeService.getLeaveTypes().subscribe(
      (res:any)=>{
        // console.log(res);
        this.leaveTypes = res.body;
      }
    )
  }

  getOrganizations():void{
    this.organizationService.getOrganizations().subscribe(
      (res:any)=>{
        this.organizations = res.body;
      }
    );
  }

  createorgLeaveForm(){
    this.orgLeaveForm = this.fb.group({
      leaves:['',[Validators.required,Validators.min(0)]],
      leave_type: ['',[Validators.required]],
      leaves_for_year: [moment(),[Validators.required]],
      org_id	: [this.orgId]
    })
  }

  get orgLeaveFormValidate(){
    return this.orgLeaveForm.controls;
  }

  orgLeaveFormSubmit(){
    if(this.orgLeaveForm.invalid){
      return;
    }

    let leaves_for_year = this.orgLeaveForm.value.leaves_for_year
    this.orgLeaveForm.get("leaves_for_year").patchValue(leaves_for_year.year(), { emitEvent: false });
    this.orgLeaveService.createOrganizationLeave(this.orgLeaveForm.value).subscribe(
      (res)=>{
        this.orgLeaveForm.reset();
        this.myForm.resetForm();
        this.isShowAlert= true;
        this.closeAlertMessage();
        this.createorgLeaveForm();
        this.checkAuthenticationType();
      }
    )
  }

  cancel():void{
    this.dialog.closeAll();
  }

  closeAlertMessage(){
    setTimeout(()=>{
      this.isShowAlert=false;
    },5000);
  }

  chosenYearHandler(normalizedYear: Moment,datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.orgLeaveForm.value.leaves_for_year;
    ctrlValue.year(normalizedYear.year());
    this.orgLeaveForm.get("leaves_for_year").patchValue(ctrlValue, { emitEvent: false });
    datepicker.close();
  }

 

}

